module.exports = __webpack_public_path__ + "img/slide-42.03d71e84.jpeg";